interface EnglishPanelProps {
  english: string;
}

/** English is a reference layer, never the reply — hence the secondary kicker. */
export function EnglishPanel({ english }: EnglishPanelProps) {
  return (
    <section className="english-panel" aria-label="English reference">
      <p className="kicker english-panel-kicker">English · secondary</p>
      <p className="english-panel-body">{english}</p>
    </section>
  );
}
